import { useCallback } from 'react';

import { saveDraftConsent } from '../api/saveDraftConsent';
import { useAppSelector } from './hooks';
import useArnFromPath from './useArnFromPath';
import useSettings from './useSettings';

/**
 * Initializes a service for saving draft consent
 *
 * @returns service function for saving draft consent
 */
const useSaveDraftConsent = () => {
    const { authenticationData } = useAppSelector((state) => state.authentication);
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();

    const saveDraft = useCallback(
        async (publicId: string, type: 'SBL' | 'NORSK_GJELDSREGISTER') => {
            if (!authenticationData) {
                throw Error('Not authenticated');
            }

            return await saveDraftConsent(
                proxyBaseUrl,
                apiKey,
                authenticationData,
                applicationReferenceNumber!,
                publicId,
                type,
            );
        },

        [authenticationData, apiKey, proxyBaseUrl, applicationReferenceNumber],
    );

    return saveDraft;
};

export default useSaveDraftConsent;
